import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import QueryString from 'query-string'
import { View, ActivityIndicator, Text, Platform } from 'react-native'
import ImageComponent from './../../components/Image'
import loginActions from '../../redux/login/loginActions'
import { getEquipmentTypes, getTimeZone, getAvatar, getHotOffers, getOffers } from '../../redux/initReducer/initActions'
import { storeGet } from '../../tools/storage'
import * as app from '../../../app.json'
import { useChat } from '../../tools/general'
import ParticlesBackground from '../../components/ParticlesBackground'

function Splash () {
  const dispatch = useDispatch()
  const initChat = useChat()
  const [queryParams] = useState(Platform.OS === 'web' ? QueryString.parse(location.search) : null)
  useEffect(() => {
    const tryLogin = async () => {
      const user = await storeGet() || {}
      if (queryParams && queryParams.email && user?.auth) {
        if (Object.keys(queryParams).length === 1) {
          dispatch(loginActions.logout())
          return
        }
      }
      const { auth } = user
      if (!auth?.access_token) {
        setTimeout(() => dispatch(loginActions.didTryAutoLogin()), 3000)
        return
      }
      if (new Date().getTime() >= auth?.expiration) {
        dispatch(loginActions.logout())
        return
      }

      initChat(user.email)
      // TODO MEJORAR
      dispatch(getEquipmentTypes())
      dispatch(getTimeZone())
      dispatch(getAvatar())
      dispatch(getHotOffers())
      dispatch(getOffers())
      // if (Platform.OS !== 'web') {
      //   alert("Due to schedule maintenance, Edge Capacity services won't be available from Sunday afternoon to Monday morning")
      // }
      setTimeout(() => dispatch(loginActions.loginSuccess(user)), 3000)
    }

    tryLogin()
  }, [dispatch, initChat, queryParams])

  return (
    <View style={{ flex: 1 }}>
      <ParticlesBackground>
        <View style={{ flex: 12, justifyContent: 'center', alignItems: 'center' }}>
          <View style={{ height: 65, width: '100%', marginBottom: 20 }}>
            <ImageComponent name='logoLight' />
          </View>
          <ActivityIndicator color='#FFF' />
        </View>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <Text style={{ color: '#FFF' }}>v{app.expo.version}</Text>
        </View>
      </ParticlesBackground>
    </View>
  )
}

export default Splash
